import loadCaptchaScript from './loadCaptchaScript';
import renderCaptchaWidget from './renderCaptchaWidget';

/**
 * @module yandex-captcha/initAndRenderCaptchaWidget
 * @description
 * Метод вызывает загрузку скрипта Yandex Captcha, если он ещё не был загружен, а затем рендерит виджет капчи в переданном блоке.
 *
 * Метод может быть использован для рендера капчи в различных кастомных формах.
 * Также, метод используется в обработчиках стандартных форм в качестве фоллбека на тот случай если Intersection Observer API отработает некорректно.
 *
 * Примечания:
 * (!) Если ничего не передать в метод, то произойдёт попытка загрузить скрипт капчи, если он ещё не загружен.
 * (!) Блок передаваемый в качестве аргумента (container) должен быть пустым
 * (!) Если у переданного блока есть атрибут data-yandex-captcha-type="invisible", то будет вызван рендер Yandex Captcha Invisible.
 *
 * @param {HTMLElement} container - DOM-элемент, в котором будет рендериться капча.
 *
 * @param {Object} context - Вручную передавать не нужно, используется только для фоллбека из наших UI-компонентов форм.
 * @param {Object} renderParams - Параметры рендера капчи. Если не переданы, то будут использованы значения по умолчанию.
 * @param {string} formType - Тип формы, для которой рендерится капча. Возможные значения: "feedback", "comment", "review".
 *
 * @example
 * window.yandexCaptchaCommon.initAndRenderCaptchaWidget(document.querySelector('.js-captcha-block'));
 *
 * @returns {void}
 */
export default function({ container, context, renderParams, formType } = {}) {
  const renderCallback = () => {
    if (container && container.children.length) {
      console.warn('Попытка рендера Yandex Captcha в блоке, который уже содержит элементы. ', container);
      window.EventBus.unsubscribe('yandex-captcha-api:insales:loaded', renderCallback);

      return;
    }

    try {
      renderCaptchaWidget({
        container,
        context,
        renderParams,
        formType
      });

      window.EventBus.unsubscribe('yandex-captcha-api:insales:loaded', renderCallback);
    } catch (catchErrorMessage) {
      console.warn('Произошла ошибка при попытке рендера Yandex Captcha: ', {
        message: catchErrorMessage,
        container: container,
        context,
        renderParams,
        formType
      });
    }
  };

  if (container) {
    window.EventBus.subscribe('yandex-captcha-api:insales:loaded', renderCallback);
  }

  window.yandexCaptchaAPICallback = function() {
    window.EventBus.publish('yandex-captcha-api:insales:loaded', null);
  };

  if (
    window.Shop.config.config.feedback_captcha_enabled
    || window.Shop.config.theme_settings.feedback_captcha_enabled
  ) {
    loadCaptchaScript(
      'yandexCaptchaAPICallback',
      window.yandexCaptchaAPICallback
    );
  }
}
